<template>
    <section>
        <div 
            class="modal fade preview-grouped-modal-lg" 
            tabindex="-1" 
            role="dialog" 
            id="preview-grouped-analyses-modal"
        >
            <div class="modal-dialog modal-lg fullscreen-modal" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Prévisualisation | Groupage de résultats d’analyses</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <GroupedAnalysisResultsPDF :results="results" />
                    </div>

                    <div class="modal-footer py-1">
                        <b-button variant="outline-secondary" data-dismiss="modal" class="btn-radius btn-secondary-light-o" @click="$emit('cancel')">
                            Annuler tout
                        </b-button>
                        <button 
                            type="button" 
                            class="ui-print-action btn btn-success btn-radius"
                            @click="printGroupedResultatAnalyse()" 
                            :disabled="is_printing"
                        >
                            <span v-if="is_printing" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Imprimer
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- <vue-html2pdf
            ref="grouped-results-pdf"
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="793px"
            @progress="onProgress($event)"
            @startPagination="startPagination()"
            @hasPaginated="hasPaginated()"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            @beforeDownload="beforeDownload($event, 'a4', '')"
            @hasDownloaded="hasDownloaded($event)"
            :filename="'grouped-results-' + new Date().toISOString()"
            v-if="results"
        >
            <section slot="pdf-content">
                
            </section>
        </vue-html2pdf> -->
    </section>
</template>

<script>
import GroupedAnalysisResultsPDF from './GroupedAnalysisResultsPDF.vue'

import $ from 'jquery';
import { getFormattedDateTime } from '@/utils/datetime'
import { showToast } from '@/utils/notifications'

export default {
    name: "preview-grouped-analyses-modal",
    props: [],
    components: {
        GroupedAnalysisResultsPDF,
    },
    data() {
        return {
            can_print: false
        }
    },
    computed: {
        results() {
            return this.$store.getters['groupedResults'];
        }
    },

    mounted() {
    },

    methods: {
        getFormattedDateTime,
        headerRowLength(result) {
            let maxLength = 0;
            if (result && result.data !== null) {
                for (const row of result.data) {
                    maxLength = Math.max(maxLength, row.cells.length);
                }
            }
            return maxLength;
        },

        removeParagraph(text) {
            return text == null ? text : text.replace(/<p>/g, '').replace(/<\/p>/g, '');
        },

        hasDownloaded() {
            $('#preview-grouped-analyses-modal').modal('hide');
            showToast('Le PDF a été généré avec succès');
        },

        printGroupedResultatAnalyse() {
            this.$emit('emitSetGroupedResultToPrint', this.results)
        },
    }

}
</script>

<style src="./styles/preview-grouped-modal.scss" lang="scss" scoped></style>
